import { render, staticRenderFns } from "./LeonidaAccettazioneTariffeList.vue?vue&type=template&id=83c4efc2"
import script from "./LeonidaAccettazioneTariffeList.vue?vue&type=script&lang=js"
export * from "./LeonidaAccettazioneTariffeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports